'use strict';
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1 from "./scala.scalajs.runtime.-Anon-Function1.$$-Lambda$412915ce24663401f4bc24349a746e1dbd693dc1.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_laminar_keys_EventProcessor(eventProp, shouldUseCapture, shouldBePassive, processor) {
  this.hz = null;
  this.jJ = false;
  this.jI = false;
  this.jH = null;
  this.hz = eventProp;
  this.jJ = shouldUseCapture;
  this.jI = shouldBePassive;
  this.jH = processor;
}
export { $c_Lcom_raquo_laminar_keys_EventProcessor as $c_Lcom_raquo_laminar_keys_EventProcessor };
$p = $c_Lcom_raquo_laminar_keys_EventProcessor.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_laminar_keys_EventProcessor;
/** @constructor */
function $h_Lcom_raquo_laminar_keys_EventProcessor() {
}
export { $h_Lcom_raquo_laminar_keys_EventProcessor as $h_Lcom_raquo_laminar_keys_EventProcessor };
$h_Lcom_raquo_laminar_keys_EventProcessor.prototype = $p;
$p.il = (function(project) {
  var newProcessor = new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((ev) => {
    var this$2 = this.jH.j(ev);
    return (this$2.k() ? $j_java$002elang$002e$002dObject.$m_s_None$() : new $j_java$002elang$002e$002dObject.$c_s_Some(project.j(this$2.C())));
  }));
  return new $c_Lcom_raquo_laminar_keys_EventProcessor(this.hz, this.jJ, this.jI, newProcessor);
});
$p.uh = (function(value) {
  var newProcessor = new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((ev) => {
    var this$2 = this.jH.j(ev);
    return (this$2.k() ? $j_java$002elang$002e$002dObject.$m_s_None$() : new $j_java$002elang$002e$002dObject.$c_s_Some((this$2.C(), value.h())));
  }));
  return new $c_Lcom_raquo_laminar_keys_EventProcessor(this.hz, this.jJ, this.jI, newProcessor);
});
$p.C3 = (function(value) {
  var newProcessor = new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((ev) => {
    var this$2 = this.jH.j(ev);
    return (this$2.k() ? $j_java$002elang$002e$002dObject.$m_s_None$() : (this$2.C(), new $j_java$002elang$002e$002dObject.$c_s_Some(value)));
  }));
  return new $c_Lcom_raquo_laminar_keys_EventProcessor(this.hz, this.jJ, this.jI, newProcessor);
});
$p.js = (function() {
  var newProcessor = new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((ev) => {
    var this$2 = this.jH.j(ev);
    if (this$2.k()) {
      return $j_java$002elang$002e$002dObject.$m_s_None$();
    } else {
      this$2.C();
      var x = $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_DomApi$().V1(ev.target);
      return new $j_java$002elang$002e$002dObject.$c_s_Some(((x === (void 0)) ? "" : x));
    }
  }));
  return new $c_Lcom_raquo_laminar_keys_EventProcessor(this.hz, this.jJ, this.jI, newProcessor);
});
$p.VY = (function() {
  var newProcessor = new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((ev) => {
    var this$2 = this.jH.j(ev);
    if (this$2.k()) {
      return $j_java$002elang$002e$002dObject.$m_s_None$();
    } else {
      this$2.C();
      var x = $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_DomApi$().UN(ev.target);
      return new $j_java$002elang$002e$002dObject.$c_s_Some((!(!((x === (void 0)) ? false : x))));
    }
  }));
  return new $c_Lcom_raquo_laminar_keys_EventProcessor(this.hz, this.jJ, this.jI, newProcessor);
});
var $d_Lcom_raquo_laminar_keys_EventProcessor = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_laminar_keys_EventProcessor, "com.raquo.laminar.keys.EventProcessor", ({
  ij: 1
}));
export { $d_Lcom_raquo_laminar_keys_EventProcessor as $d_Lcom_raquo_laminar_keys_EventProcessor };
